import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/rotasInfo.css";

export function RotasInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();
    // console.log("id agenda aqui: ", id);

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllRotasById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    console.log(data)

    return (
        <div>
            <div className="container-rotas-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Rotas</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main key={i} className="datagrid-container">
                            <div className="table-content">
                                <div key={i}>
                                    <h3>Agenda ID: {check.id}</h3>
                                    <thead>
                                        <tr>
                                            <th>Área</th>
                                            <th>Desvio identificado</th>
                                            <th>Itens Identificados</th>
                                            <th>Classificação de risco</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.area
                                                ? check.area
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.desvio_identificado
                                                ? check.desvio_identificado
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.ds_itens
                                                ? check.ds_itens
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.classificacao
                                                ? check.classificacao
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Ação imediata tomada</th>
                                            <th>Ação preventiva</th>
                                            <th>Prazo</th>
                                            <th>Responsavel</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.acao_imediata
                                                ? check.acao_imediata
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.acao_preventiva || ""
                                                ? check.acao_preventiva
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.prazo
                                                ? formatDate(check.prazo)
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.responsavel || ""
                                                ? check.responsavel
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
